import CartRewardBanner from '@/components/cart-reward-banner';

function initialiseCartRewardBanner() {
  window.theme.cartRewardBanner.instance = new CartRewardBanner({
    rewardTiers: window.theme.cartRewardBanner.rewardTiers ?? [],
    cartTotal: window?.theme?.cartRewardBanner?.cartTotal
      ? window.theme.cartRewardBanner.cartTotal / 100
      : 0,
    rootElement: document.querySelector('.unlock-free-bonus')!,
    blacklistedProperties: ['__free_gift'],
    verbose: true,
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initialiseCartRewardBanner();
});
